// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './config/rem.js'
import './style/reset.less'
import { Carousel, CarouselItem, Input, Form, FormItem, Button, Pagination, Drawer, Message } from 'element-ui'

Vue.config.productionTip = false

Vue.prototype.$message = Message

Vue.prototype.$top = function(){
  var timer = setInterval(function(){
    let osTop = document.documentElement.scrollTop || document.body.scrollTop;
    let ispeed = Math.floor(-osTop / 5); 
    document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
    if(osTop === 0){
      clearInterval(timer);
    }
  },30)
}

Vue.use(Carousel).use(CarouselItem).use(Input).use(Form).use(FormItem).use(Button).use(Pagination).use(Drawer)


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js